
export default (state = { show: false, message: "", showBar: false }, action) => {
  switch (action.type) {
    case "SET_ERROR":
      return { ...state, ...action.payload }
    default:
      return state
  }
}